const InfoBox = (props) => {
    return (
        <div className='absolute bottom-0 right-0 bg-blue-400 m-10 px-5 py-3 rounded-lg text-white flex flex-row'>
            {props.message}
        </div>
    )
}

export default InfoBox;